/*
 * pkcs7
 * https://github.com/brightcove/pkcs7
 *
 * Copyright (c) 2014 Brightcove
 * Licensed under the apache2 license.
 */

'use strict';

exports.pad = require('./pad.js');
exports.unpad = require('./unpad.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/pkcs7/lib/pkcs7.js
// module id = iKht
// module chunks = 0